﻿import { useEffect, useRef, useState } from "react";
import { useToasts } from "react-toast-notifications";
import { useNavigate } from "react-router-dom";

import classes from "../../../purchase.module.scss";

import { ReactComponent as ActionSvg } from "@/assets/images/desktop/opciones.svg";
import Fetching from "@/components/Fetching/Fetching";
import BasicConfirm from "@/components/Confirm/BasicConfirm";

import { hasPermission } from "@/services/Utils";

import { useOrderReturnPaginate, useOrderReturnDelete } from "@/hooks/purchases/orders_return";

const OrdersReturnActionItem = ({ item, indice, data, setData, base }) => {
	const { addToast } = useToasts();

	const { mutate: remove, isLoading: loadDelete } = useOrderReturnDelete(base);

	const { data: response } = useOrderReturnPaginate(base);
	const { permissions } = response;

	const navigate = useNavigate();

	const refButton = useRef(null);
	const refDiv = useRef(null);

	const [showDelete, setShowDelete] = useState(false);

	const handleClickOutside = (event) => {
		if (refButton.current && !refButton.current.contains(event.target) && refDiv.current && !refDiv.current.contains(event.target)) {
			let newData = [...data];
			newData[indice].show_action = false;
			setData(newData);
		}
	};

	const showAction = (indice) => {
		let newData = [...data];
		newData[indice].show_action = !newData[indice].show_action;
		setData(newData);
	};

	const handleEdit = (item) => {
		let newData = [...data];
		newData[indice].show_action = false;
		setData(newData);

		navigate(`/nota_credito/editar/${item.code}`);
	};

	const handleDelete = () => {
		setShowDelete(false);

		const request = {
			base,
			element: item,
		};

		remove(request, {
			onSuccess: (_response) => {
				addToast(`Nota de crédito eliminada correctamente.`, {
					appearance: "success",
				});
			},
		});
	};

	useEffect(() => {
		document.addEventListener("click", handleClickOutside, true);
		// eslint-disable-next-line
	}, []);

	return (
		<>
			{loadDelete ? <Fetching topMargin={"0px"} /> : <ActionSvg className={classes.icon} onClick={() => showAction(indice)} ref={refButton} />}

			{!item.show_action ? (
				""
			) : (
				<div className={`${classes.floating} ${classes.divAction}`} ref={refDiv}>
					<h4>Acciones</h4>
					<table className={classes.tableAction}>
						<tbody>
							{hasPermission("edit", permissions) && (
								<tr style={{ cursor: "pointer" }} onClick={() => handleEdit(item)}>
									<td className={classes.tdEdit}>
										<span className={classes.tdSpan}>Editar</span>
									</td>
								</tr>
							)}

							{hasPermission("delete", permissions) && (
								<tr
									style={{ cursor: "pointer" }}
									onClick={() => {
										let newData = [...data];
										newData[indice].show_action = false;
										setData(newData);

										setShowDelete(true);
									}}
								>
									<td className={classes.tdDelete}>
										<span className={classes.tdSpan}>Eliminar</span>
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
			)}

			<BasicConfirm
				message={"¿Está seguro de que desea eliminar la nota de crédito seleccionada?"}
				showConfirm={showDelete}
				setShowConfirm={setShowDelete}
				handleAction={handleDelete}
				showValidation={true}
				textValidation={"eliminar la nota de crédito"}
			/>
		</>
	);
};

export default OrdersReturnActionItem;
